var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-nocheck
import { useState, useEffect } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { jwtDecode } from 'jwt-decode';
/**
 * Custom hook for checking and loading images with security validation
 */
export var useImageChecker = function () {
    var _a = useState(null), imageData = _a[0], setImageData = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var notify = useNotify();
    var translate = useTranslate();
    var checkImage = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var errorMsg, result, err_1, errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!url) {
                        errorMsg = translate('error.imageChecker.noUrl');
                        setError(errorMsg);
                        notify(errorMsg, { type: 'error' });
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    setError(null);
                    setImageData(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, validateAndLoadImage(url, notify, translate)];
                case 2:
                    result = _a.sent();
                    if (result.isValid && result.imageData) {
                        setImageData(result.imageData);
                    }
                    else {
                        setError(result.error || translate('error.imageChecker.unknown'));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    errorMsg = translate('error.imageChecker.loadFailed');
                    setError(errorMsg);
                    notify(errorMsg, { type: 'error' });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        imageData: imageData,
        isLoading: isLoading,
        error: error,
        checkImage: checkImage
    };
};
/**
 * Core validation and loading function
 */
export var validateAndLoadImage = function (url, notify, translate) { return __awaiter(void 0, void 0, void 0, function () {
    var allWarnings, originCheck, tokenResult, errorMsg, imageData, title, separator, formattedWarnings, warningMessage, error_1, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allWarnings = [];
                originCheck = validateOriginAndProtocol(url, translate);
                if (!originCheck.isValid) {
                    return [2 /*return*/, {
                            isValid: false,
                            error: originCheck.warnings[0] // Invalid URL is still an error
                        }];
                }
                allWarnings.push.apply(allWarnings, originCheck.warnings);
                tokenResult = getAccessTokenWithFallback(translate);
                if (!tokenResult.token) {
                    errorMsg = translate('error.imageChecker.noAccessToken');
                    notify(errorMsg, { type: 'error' });
                    return [2 /*return*/, {
                            isValid: false,
                            error: errorMsg
                        }];
                }
                allWarnings.push.apply(allWarnings, tokenResult.warnings);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, loadImageWithAuth(url, tokenResult.token)];
            case 2:
                imageData = _a.sent();
                // Display all warnings together in a single notification
                if (allWarnings.length > 0) {
                    title = translate('warning.imageChecker.multipleIssues');
                    separator = ' • ';
                    formattedWarnings = allWarnings.map(function (warning, index) { return "".concat(index + 1, ". ").concat(warning); });
                    warningMessage = "".concat(title, ": ").concat(formattedWarnings.join(separator));
                    notify(warningMessage, {
                        type: 'warning',
                        autoHideDuration: 10000 // Longer duration for multiple warnings
                    });
                    console.warn('Image loaded with warnings:', allWarnings);
                }
                return [2 /*return*/, {
                        isValid: true,
                        imageData: imageData
                    }];
            case 3:
                error_1 = _a.sent();
                errorMsg = translate('error.imageChecker.loadFailed');
                notify(errorMsg, { type: 'error' });
                return [2 /*return*/, {
                        isValid: false,
                        error: errorMsg
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Step 1: Validate origin and protocol
 */
var validateOriginAndProtocol = function (url, translate) {
    var warnings = [];
    try {
        var imageUrl = new URL(url);
        var currentOrigin = window.location.origin;
        var currentUrl = new URL(currentOrigin);
        // Check if protocol is HTTPS
        if (imageUrl.protocol !== 'https:') {
            var warningMsg = translate('error.imageChecker.notHttps');
            warnings.push(warningMsg);
        }
        // Check if same origin
        if (imageUrl.origin !== currentUrl.origin) {
            var baseMsg = translate('error.imageChecker.differentOrigin');
            var warningMsg = interpolateMessage(baseMsg, {
                imageOrigin: imageUrl.origin,
                currentOrigin: currentUrl.origin
            });
            warnings.push(warningMsg);
        }
        return { isValid: true, warnings: warnings };
    }
    catch (error) {
        var errorMsg = translate('error.imageChecker.invalidUrl');
        return {
            isValid: false,
            warnings: [errorMsg]
        };
    }
};
/**
 * Step 2: Get access token with fallback and warnings
 */
var getAccessTokenWithFallback = function (translate) {
    var warnings = [];
    var token = null;
    // Try to get token from cookie first
    var cookieAccessToken = getCookieValue('accessToken');
    if (!cookieAccessToken) {
        var warningMsg = translate('error.imageChecker.noCookieToken');
        warnings.push(warningMsg);
        // Fallback to localStorage
        token = localStorage.getItem('accessToken');
        if (!token) {
            return { token: null, warnings: warnings };
        }
    }
    else {
        token = cookieAccessToken;
    }
    // Check if token is expired
    try {
        var decodedToken = jwtDecode(token);
        var currentTime = Math.floor(Date.now() / 1000);
        if (decodedToken.exp && decodedToken.exp < currentTime) {
            var warningMsg = translate('error.imageChecker.tokenExpired');
            warnings.push(warningMsg);
            // Still return the token - let the server decide if it's acceptable
        }
    }
    catch (error) {
        var warningMsg = translate('error.imageChecker.invalidToken');
        warnings.push(warningMsg);
        // Still return the token - let the server decide if it's acceptable
    }
    return { token: token, warnings: warnings };
};
/**
 * Step 3: Load image with authentication
 */
var loadImageWithAuth = function (url, token) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, response, contentType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                headers = {
                    'Accept': 'image/*',
                };
                // Add authorization header if token is available
                if (token) {
                    headers['Authorization'] = "Bearer ".concat(token);
                }
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: headers,
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("HTTP error! status: ".concat(response.status));
                }
                contentType = response.headers.get('content-type');
                if (!contentType || !contentType.startsWith('image/')) {
                    throw new Error('Response is not an image');
                }
                return [4 /*yield*/, response.blob()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Helper function to interpolate message templates
 */
var interpolateMessage = function (template, params) {
    var result = template;
    Object.keys(params).forEach(function (key) {
        var placeholder = "{{".concat(key, "}}");
        result = result.replace(new RegExp(placeholder, 'g'), params[key]);
    });
    return result;
};
/**
 * Helper function to get cookie value
 */
var getCookieValue = function (name) {
    var _a;
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) {
        return ((_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift()) || null;
    }
    return null;
};
export var SecureImage = function (_a) {
    var src = _a.src, _b = _a.alt, alt = _b === void 0 ? "Secure image" : _b, style = _a.style, onError = _a.onError, onLoad = _a.onLoad;
    var _c = useImageChecker(), imageData = _c.imageData, isLoading = _c.isLoading, error = _c.error, checkImage = _c.checkImage;
    var _d = useState(null), objectUrl = _d[0], setObjectUrl = _d[1];
    useEffect(function () {
        if (src) {
            checkImage(src);
        }
    }, [src]);
    useEffect(function () {
        if (imageData) {
            var url_1 = URL.createObjectURL(imageData);
            setObjectUrl(url_1);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad();
            // Cleanup function
            return function () {
                URL.revokeObjectURL(url_1);
            };
        }
    }, [imageData, onLoad]);
    useEffect(function () {
        if (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }, [error, onError]);
    if (isLoading) {
        return (_jsx("div", { style: __assign(__assign({}, style), { display: 'flex', alignItems: 'center', justifyContent: 'center' }), children: "Loading..." }));
    }
    if (error || !objectUrl) {
        return (_jsx("div", { style: __assign(__assign({}, style), { display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }), children: _jsx("span", { style: { color: '#666', fontSize: '12px' }, children: error || 'Failed to load image' }) }));
    }
    return (_jsx("img", { src: objectUrl, alt: alt, style: style, onError: function () { return onError === null || onError === void 0 ? void 0 : onError('Image rendering failed'); } }));
};
export default {
    useImageChecker: useImageChecker,
    validateAndLoadImage: validateAndLoadImage,
    SecureImage: SecureImage
};
